import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=975b1902&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=975b1902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975b1902",
  null
  
)

export default component.exports